document.addEventListener("DOMContentLoaded", () => {

    const popup = document.getElementById("sales-popup");

    if (!popup) return;

    const title = popup.querySelector(".sales-popup__title");
    const close = popup.querySelector(".sales-popup-close");

    let stop = false;

    const notifications = [

        {
            text: "🛒 Someone added this item to cart",
            wait: 7000
        },

        {
            text: "💳 Someone started checkout",
            wait: 5000
        },

        {
            text: "✅ Someone purchased this item",
            wait: 7000
        }

    ];

    close.addEventListener("click", () => {

        stop = true;

        popup.classList.remove("show");

    });

    function play(index){

        if(stop) return;

        if(!notifications[index]) return;

        title.innerHTML = notifications[index].text;

        popup.classList.add("show");

        setTimeout(()=>{

            popup.classList.remove("show");

            if(notifications[index+1] && !stop){

                setTimeout(()=>{

                    play(index+1);

                },notifications[index+1].wait);

            }

        },4000);

    }

    setTimeout(()=>{

        play(0);

    },notifications[0].wait);

});